module.exports = __webpack_public_path__ + "img/calendar-week.56294fc4.svg";